import { api } from './client';
import type { Batch, BatchData, BatchVersionSummary } from '../types';

export function listBatches(): Promise<{ items: Batch[] }> {
  return api('/api/batches');
}

export function createBatch(data: BatchData): Promise<Batch> {
  return api('/api/batches', {
    method: 'POST',
    body: JSON.stringify({ data }),
  });
}

export function updateBatch(
  id: string,
  data: BatchData,
  expectedUpdatedAt: number,
): Promise<Batch> {
  return api(`/api/batches/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ data, expected_updated_at: expectedUpdatedAt }),
  });
}

export function deleteBatch(id: string): Promise<{ ok: true }> {
  return api(`/api/batches/${id}`, { method: 'DELETE' });
}

export function batchChanges(sinceMs: number): Promise<{
  server_time: number;
  updated: Batch[];
  deleted: { id: string; deleted_at: number }[];
}> {
  return api(`/api/batches/changes?since=${sinceMs}`);
}

export function listVersions(
  batchId: string,
): Promise<{ versions: BatchVersionSummary[] }> {
  return api(`/api/batches/${batchId}/versions`);
}

export function getVersion(
  batchId: string,
  versionId: number,
): Promise<{ id: number; data: BatchData; saved_by: string | null; saved_at: number }> {
  return api(`/api/batches/${batchId}/versions/${versionId}`);
}

export function restoreVersion(
  batchId: string,
  versionId: number,
): Promise<Batch> {
  return api(`/api/batches/${batchId}/versions/${versionId}`, {
    method: 'POST',
  });
}
